import {useState} from 'react'
import {Button, SelectPanel} from '@primer/react'
import type {SelectPanelItemInput as ItemInput} from '@primer/react'
import {TriangleDownIcon} from '@primer/octicons-react'

interface FilterLabelsProps {
  items: ItemInput[]
  labelsText: string
  selectedLabels: ItemInput[]
  onChangeLabels: (selected: ItemInput[]) => void
  applyLabels: () => void
  resetLabels: () => void
}

function FilterLabels(props: FilterLabelsProps) {
  const [open, setOpen] = useState(false)
  const [filter, setFilter] = useState('')
  const filteredItems = props.items.filter(item => item?.text?.toLowerCase().startsWith(filter.toLowerCase()))

  return (
    <SelectPanel
      title="Select labels"
      renderAnchor={({children, ...anchorProps}) =>
        props.items.length === 0 ? (
          <Button {...anchorProps} trailingAction={TriangleDownIcon} aria-haspopup="dialog">
            No labels available
          </Button>
        ) : (
          <Button {...anchorProps} trailingAction={TriangleDownIcon} aria-haspopup="dialog">
            <span className="color-fg-muted">Labels: </span>
            <span id="select-labels">{props.labelsText}</span>
          </Button>
        )
      }
      placeholder="Filter labels"
      open={open}
      onCancel={props.resetLabels}
      onOpenChange={(isOpen, gesture) => {
        setOpen(isOpen)
        if (gesture === 'click-outside') {
          props.applyLabels()
        }
      }}
      items={filteredItems}
      selected={props.selectedLabels}
      onSelectedChange={props.onChangeLabels}
      onFilterChange={setFilter}
      showItemDividers
      overlayProps={{
        width: 'small',
        height: 'medium',
        maxHeight: 'medium',
      }}
    />
  )
}

export default FilterLabels
